export default __webpack_public_path__ + "static/media/Excel.ab0fde55.GIF";